export default __webpack_public_path__ + "static/media/Slide28.68980362.jpg";